import { render, staticRenderFns } from "./EditIndustrialPropertyDetail.vue?vue&type=template&id=62a9e608"
import script from "./EditIndustrialPropertyDetail.vue?vue&type=script&lang=js"
export * from "./EditIndustrialPropertyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports